export default __webpack_public_path__ + "static/media/bad.2cda159e.svg";